<div id="eventList" class="ya-typography">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop" (swiperight)="navigateBack()">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="event-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="eventViewModel.image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="event-detail-wrapper">
        <section class="event-detail-content">
          <div class="event-detail-page-content-header ya-detail-page-header">
            <div id="headerTitleContainer" class="event-detail-title">
              <h2 id="headerTitle">{{eventViewModel.label}}</h2>
            </div>
            <div class="event-detail-like">
              <ya-favoritebutton [contentType]="contentType.Event" [likeStatus]="eventViewModel.like"
                [modelId]="eventViewModel.id">
              </ya-favoritebutton>
            </div>
          </div>
          <p [innerHTML]="eventViewModel.text"> </p>
          <div class="actions">
            <div class="event-detail-ranking-bar">
              <bar-rating [(rate)]="eventViewModel.rate" [max]="5" [readOnly]="true"
                [theme]="'fontawesome-o'"></bar-rating>
              <div class="rate-click-div" (click)="openRateModel(eventViewModel)"></div>
            </div>
          </div>
          <div class="event-detail-date-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-events"></div>

            <ng-container *ngIf="eventViewModel.endDate">
              <div class="container event-detail-date-wrapper">
                <div class="container-border">
                  <div class="event-detail-date top">
                    <span class="description" langkey="phEventDetail_From"></span>
                    <span>
                      {{eventViewModel.startDate}}{{eventViewModel.startTime?", " + eventViewModel.startTime:""}}
                    </span>
                  </div>
                </div>
                <div class="event-detail-date bottom">
                  <span class="description" langkey="phEventDetail_To"></span>
                  <span>
                    {{eventViewModel.endDate}}{{eventViewModel.endTime?", " + eventViewModel.endTime:""}}
                  </span>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!eventViewModel.endDate">
              <div class="container event-detail-date-wrapper">
                <div class="container-border">
                  <div class="event-detail-date top">
                    <span class="description" langkey="phEventDetail_Date"></span>
                    <span>
                      {{eventViewModel.startDate}}{{eventViewModel.endDate?" - " + eventViewModel.endDate:""}}
                    </span>
                  </div>
                </div>
                <div class="event-detail-date bottom">
                  <span class="description" langkey="phEventDetail_Time"></span>
                  <span>
                    {{eventViewModel.startTime}}{{eventViewModel.endTime?" - " + eventViewModel.endTime:""}}
                  </span>
                </div>
              </div>
            </ng-container>
            <div class="location-icon--sticky">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
            </div>
            <mat-expansion-panel class="container event-detail-location-wrapper" (opened)="locationPanel()"
              (closed)="locationPanel()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="description" langkey="phEventDetail_Location"></span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="location-list-container">
                <ng-container *ngFor="let eventLocation of eventViewModel.locations">
                  <span>
                    {{eventLocation.label}}
                  </span>
                </ng-container>
              </p>
            </mat-expansion-panel>
          </div>
          <div class="event-counter">
            <ng-container *ngIf="!eventStarted(eventViewModel.momentStartDate)">
              <date-countdown units="Days | Hours | Minutes" divider=":" showZeros="true"
                [end]="eventViewModel.momentStartDate" (reached)="countdownEnding()"></date-countdown>
            </ng-container>
          </div>
        </section>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>